"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewFeedbackScoreSchema = void 0;
const zod_1 = require("zod");
const RubricScore = zod_1.z.object({
    type: zod_1.z.literal('RUBRIC_SCORE'),
    score: zod_1.z
        .object({
        rubric: zod_1.z.string(),
        value: zod_1.z.number().gte(0),
    })
        .array(),
});
const NumericScore = zod_1.z.object({
    type: zod_1.z.literal('NUMERIC_SCORE'),
    score: zod_1.z.number().gte(0),
});
const PassFailScore = zod_1.z.object({
    type: zod_1.z.literal('PASS_FAIL_SCORE'),
    score: zod_1.z.boolean(),
});
exports.ReviewFeedbackScoreSchema = zod_1.z.discriminatedUnion('type', [PassFailScore, NumericScore, RubricScore]);
//# sourceMappingURL=index.js.map